<template>
  <div>
    <el-table :data="withdrawData" :height="wheight-500" border v-loading="loading">
<!--      <el-table-column prop="id" label="ID" width="95"></el-table-column>-->
      <el-table-column prop="user_id" label="怡贝会员ID" width="95"></el-table-column>
      <el-table-column prop="member_account"   label="会员账号" width="130"></el-table-column>
      <el-table-column prop="amount"  label="提现金额" width="90"></el-table-column>
<!--      <el-table-column prop="amount_before"  label="提现前余额" width="90"></el-table-column>-->
<!--      <el-table-column prop="amount_after"  label="提现后余额" width="90"></el-table-column>-->
      <el-table-column prop="name"  label="真实姓名" width="80"></el-table-column>
      <el-table-column prop="approval_status" label="状态" width="130">
        <template slot-scope="scope">
          <div v-if="scope.row.approval_status!='1'">
            <el-tag v-if="scope.row.approval_status=='1'">审核通过</el-tag>
            <el-tag v-else-if="scope.row.approval_status=='2'" type="info">审核未通过</el-tag>
            <el-tag v-else type="danger">等待审核</el-tag>
          </div>
          <div v-else>
            <el-tag v-if="scope.row.billing_status=='1'">已结算</el-tag>
            <el-tag v-else-if="scope.row.billing_status=='2'" type="info">结算失败</el-tag>
            <el-tag v-else type="warning">等待结算</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="申请时间" width="250">
        <template slot-scope="scope">
          {{scope.row.add_time | datetime('yyyy-MM-dd hh:mm:ss')}}
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > pageSize" class="content-padded tc">
      <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total='total_count' :page-size="pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import { withdrawList } from '../../../api/sharer'
  import {mapGetters} from "vuex";
  export default {
    props: ['userId', 'isLoad'],
    data () {
      return {
        loading: false,
        params: {},
        total_count: 0,
        currentPage: 1,
        pageSize: 20,
        withdrawData: []
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (val) {
        this.currentPage = val
        this.loading = false
        this.getParams()
        this.getWithdrawList(this.params)
      },
      getParams () {
        this.params.page = this.currentPage
        this.params.pageSize = this.pageSize
      },
      getWithdrawList (filter) {
        this.loading = true
        console.log(filter)
        withdrawList(filter).then(response => {
          this.withdrawData = response.data.data.list
          this.total_count = Number(response.data.data.total_count)
          this.loading = false
        })
      },
    },
    mounted () {
      // this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
      // this.getWithdrawList(this.params)
    },
    watch: {
      userId (newVal, oldVal) {
        if (this.isLoad) {
          this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: newVal}
          this.getWithdrawList(this.params)
        }
      },
      isLoad (newVal, oldVal) {
        if (newVal) {
          this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
          this.getWithdrawList(this.params)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #8d8d8d;
  }
}
</style>



// WEBPACK FOOTER //
// withdrawlist.vue?61c45ada